<fw-list (OnLoad)="OnLoad($event)"
         (RoutingFieldClicked)="NavigateByContext($event)"
         [ListConfigurationViewDTO]="UserListWidgetConfigurationViewDTO"
         [ErrorMessageResourceId]="errorMessageResourceId"
         [PaginationResultModel]="PaginationResultModel"
         [IsUserList]="true">
</fw-list>
